// ====================================================================================
// SHARED CONSTANTS
// ====================================================================================

export const AGE_BUCKETS = ['18-24', '25-34', '35-44', '45-54', '55-64', '64-75', '75+'];

export const partyColors = { 
  // Added the missing backend keys here directly
  LDM: '#ff6400', 'Liberal Democrats': '#ff6400', 'Lib Dem': '##ff6400',
  'LIBERAL_DEMOCRAT': '#ff6400', 'Liberal Democrat': '#ff6400', // FIX: Added singular/underscore versions
  
  CON: '#3b82f6', 'Conservative': '#3b82f6', 'Tory': '#3b82f6',
  LABOUR: '#ef4444', 'Labour': '#ef4444', 'Lab': '#ef4444',
  GREEN: '#22c55e', 'Green': '#22c55e',
  Reform: '#12b7c6', 'REFORM': '#12b7c6',
  Other: '#64748b',
  SNP: '#fdfa00',
};

export const partyTextColors = {
  'Liberal Democrats': 'text-party-ldm', 'LDM': 'text-party-ldm',
  'LIBERAL_DEMOCRAT': 'text-party-ldm', 'Liberal Democrat': 'text-party-ldm', // FIX
  
  'Conservative': 'text-blue-400', 'CON': 'text-blue-400',
  'Labour': 'text-danger-400', 'LABOUR': 'text-danger-400',
  'Green': 'text-success-400', 'GREEN': 'text-success-400',
  'Reform': 'text-cyan-400', 'REFORM': 'text-cyan-400',
  'Other': 'text-slate-400',
  'SNP': 'text-yellow-300',
};

// ====================================================================================
// HELPER FUNCTIONS
// ====================================================================================

export const getPartyColor = (p) => {
  if (!p) return partyColors.Other;
  return partyColors[p] || 
         partyColors[p.toUpperCase()] || 
         partyColors[p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()] || 
         partyColors.Other;
};

export const getPartyTextColor = (p) => {
  if (!p) return 'text-slate-300';
  return partyTextColors[p] || 
         partyTextColors[p.toUpperCase()] || 
         partyTextColors[p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()] || 
         'text-slate-300';
};

export const formatStrategicTier = (tier) => {
  if (!tier) return "Unknown";
  const tierMap = {
    GAIN_PRIORITY: "Priority: Gain",
    GAIN_TARGET: "Target: Gain",
    DEFEND_CRITICAL: "Critical: Defend",
    DEFEND_URGENT: "Urgent: Defend",
    DEFEND_PRIORITY: "Priority: Defend",
    LONG_TERM_TARGET: "Long-Term Target",
    SAFE_HOLD: "Safe Hold",
    UNWINNABLE: "Unwinnable",
    WATCH_LIST: "Watch List",
    NO_CONTEST: "No Contest",
  };
  return tierMap[tier] || tier.replace(/_/g, ' ');
};

export const getPersuadabilityStyle = (score) => {
  const s = score || 0;
  const clampedScore = Math.max(0.2, Math.min(0.8, s));
  const normalizedScore = (clampedScore - 0.2) / (0.8 - 0.2);
  const hue = normalizedScore * 120;
  
  const color = `hsla(${hue}, 80%, 40%, 0.5)`; 
  const base = '#1e293b'; 
  
  return { 
    background: `linear-gradient(105deg, ${color} 0%, ${base} 90%)` 
  };
};

export const normalizePartyKey = (key) => {
    if (!key) return "Other";
    const k = key.toLowerCase().replace(/_/g, ' ').replace('uk', '').trim();
    if (k.includes('lab')) return "Labour";
    if (k.includes('con')) return "Conservative";
    if (k.includes('lib') || k.includes('dem')) return "Liberal Democrats";
    if (k.includes('green')) return "Green";
    if (k.includes('ref')) return "Reform UK";
    return "Other";
};